module.exports = __webpack_public_path__ + "img/brian-skosana.09298cd0.png";